import { Injectable } from '@angular/core';
import { retry, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { IAccountTasksResponse } from '../../interfaces/account/account-tasks-response';
import { IMessageTemplate } from '../../interfaces/message/message-template';
import { IMessage } from '../../interfaces/message/message';
import { IAccountVarValues } from '../../interfaces/account/account-var-values';
import { IAccountInfo } from '../../interfaces/account/account-info';
import { SharedService } from '../shared.service';

@Injectable({
  providedIn: 'root'
})
export class AccountTasksService {

  private readonly accountTasksUrl = '/ui-pages/payload/acct-tasks';
  private readonly messageTemplatesUrl = '/msg-template-admin/brands/{brandCode}/passes/{passTemplateId}/msg-templates';
  private readonly messageBroadcastingUrl = '/ver1/brands/{brandCode}/accounts/messages';
  private readonly accountVariablesUrl = '/ver1/brands/{brandCode}/accounts/{extAccountId}';
  private readonly accountInfoUrl = '/admin/acccount-info/{brandCode}/{extAccountId}';
  private readonly updateAccountUrl = "/ver1/brands/{brandCode}/accounts/{accountId}";
  private readonly runScenarioUrl = "/demo-scenario";

  private readonly refreshDaqDataUrl = "/admin/jobs/refresh-daq-data/{brandCode}";
  private readonly importInboundFeedsUrl = "/admin/jobs/import-inbound-feeds/{brandCode}";
  private readonly generateOutboundFeedsUrl = "/admin/jobs/generate-outbound-feeds/{brandCode}";
  private readonly runAndroidScannerUrl = "/admin/jobs/run-android-scanner/{brandCode}";
  private readonly triggeredActionUrl = "/admin/jobs/triggered-action/{brandCode}/{eventName}";
  private readonly rtpnBarcodeRefresherUrl = "/admin/jobs/rtpn-barcode-refresher/{brandCode}";  

  private readonly baseHeaders = new HttpHeaders()
    .set("request-origin", "csr-portal");

  constructor(
    private readonly http: HttpClient,    
    private readonly sharedService: SharedService   
  ) { }

  public getAccountTasksSession(region: string, sessionId: string): Observable<IAccountTasksResponse> {
    let baseUrl = this.sharedService.getBaseUrlByRegion(region);
    let url = baseUrl + this.accountTasksUrl;
    let headers = new HttpHeaders()
      .set("request-origin", "csr-portal")
      .set('session-id', sessionId);
    return this.http.get<IAccountTasksResponse>(url, {headers: headers, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }

  getMessageTemplates(region: string, brandCode: string, passTemplateId: number): Observable<IMessageTemplate[]> {
    let baseUrl = this.sharedService.getBaseUrlByRegion(region);
    let url = baseUrl + this.messageTemplatesUrl
      .replace('{brandCode}', brandCode)
      .replace('{passTemplateId}',passTemplateId.toString());
    return this.http.get<IMessageTemplate[]>(url, {headers: this.baseHeaders, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }  

  broadcastMessage(region: string, brandCode: string, messageBroadcasting: any) : Observable<IMessage>{
    let request: any = [
      {
        "accountId": messageBroadcasting.accountId,
        "msgCode": messageBroadcasting.messageTemplateCode,
        "passId": messageBroadcasting.passId,
        "msgHeader": messageBroadcasting.templateHeader,
        "msgBody": messageBroadcasting.templateText,
        "linkUrl": null,
      }
    ];
    let baseUrl = this.sharedService.getBaseUrlByRegion(region);
    let url = baseUrl + this.messageBroadcastingUrl
      .replace('{brandCode}', brandCode);
    return this.http.post<IMessage>(url, request, {headers: this.baseHeaders, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  } 

  getAccountVariables(region: string, brandCode: string, extAccountId: string): Observable<IAccountVarValues> {
    let baseUrl = this.sharedService.getBaseUrlByRegion(region);
    let url = baseUrl + this.accountVariablesUrl
      .replace('{brandCode}', brandCode)
      .replace('{extAccountId}', extAccountId);
      // console.log('getVarValuesUrl - url', url); 
    return this.http.get<IAccountVarValues>(url, {headers: this.baseHeaders, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }  

  getAccountInfo(region: string, brandCode: string, extAccountId: string): Observable<IAccountInfo> {
    let baseUrl = this.sharedService.getBaseUrlByRegion(region);
    let url = baseUrl + this.accountInfoUrl
      .replace('{brandCode}', brandCode)
      .replace('{extAccountId}', extAccountId);
      // console.log('getVarValuesUrl - url', url); 
    return this.http.get<IAccountInfo>(url, {headers: this.baseHeaders, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }
  
  updateAccount(region: string, brandCode: string, accountId: string, map: any) : Observable<IMessage>{
    let jsonObject: any = {};  
    map.forEach((value: string, key: string) => {  
        jsonObject[key] = value  
    }); 
    let request = {
      "accountId": accountId,
      "values": jsonObject 
    };
    let baseUrl = this.sharedService.getBaseUrlByRegion(region);
    let url = baseUrl + this.updateAccountUrl.replace('{brandCode}', brandCode).replace('{accountId}', accountId);
    return this.http.put<IMessage>(url, request, {headers: this.baseHeaders, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  } 
  
  runScenario(region: string, brandCode: string, accountId: string, scenarioName: string, amountDueChange: any,
      standardAmountsMap: any): Observable<IMessage>{
   let jsonObject:any = {};  
   standardAmountsMap.forEach((value: string, key: string) => {  
       jsonObject[key] = value  
   }); 
   let request = {
     "brandCode": brandCode,
     "accountId": accountId,
     "scenarioName": scenarioName,
     "dueChangeAmount": amountDueChange,
     "industryAmountMap": jsonObject 
   };
   let baseUrl = this.sharedService.getBaseUrlByRegion(region);
   let url = baseUrl + this.runScenarioUrl;
   return this.http.post<IMessage>(url, request, {headers: this.baseHeaders, responseType: 'json'})
   .pipe(
    catchError(this.sharedService.handleError)
    )
 }  
 
//  triggerEvent(region: string, brandCode: string, taskName: string) {
//   let url!: any;
//   let baseUrl = this.sharedService.getBaseUrlByRegion(region);
//   if (taskName.indexOf("DaqDataBatchRefresher") >= 0) {
//     url = baseUrl || this.refreshDaqDataUrl.replace('{brandCode}', brandCode);
//   } else if (taskName.indexOf("GenericDaqDatafeedImporter") >= 0) {
//     url = baseUrl || this.importInboundFeedsUrl.replace('{brandCode}', brandCode);
//   } else if (taskName.indexOf("GenericOutgoingDatafeedGenerator") >= 0) {
//     url = baseUrl || this.generateOutboundFeedsUrl.replace('{brandCode}', brandCode);
//   } else if (taskName.indexOf("AndroidPayScanner") >= 0) {
//     url = baseUrl || this.runAndroidScannerUrl.replace('{brandCode}', brandCode);
//   } else if (taskName.indexOf("RtpnBatchBarcodeRefresher") >= 0) {
//     url = baseUrl || this.rtpnBarcodeRefresherUrl.replace('{brandCode}', brandCode);
//   } else {
//     url = baseUrl || this.triggeredActionUrl.replace('{brandCode}', brandCode).replace('{eventName}', taskName);
//   }
//   return this.http.post<IMessage>(url, null, {headers: this.baseHeaders, responseType: 'json'})
//   .pipe(
//    catchError(this.sharedService.handleError)
//    )

//  }

  triggerEvent(region: string, brandCode: string, taskName: string): Observable<IMessage> {
    switch(taskName) {
      case "DaqDataBatchRefresher":
        return this.runDaqDataBatchRefresher(region, brandCode);
      case "GenericDaqDatafeedImporter":
        return this.runGenericDaqDatafeedImporter(region, brandCode);
      case "GenericOutgoingDatafeedGenerator":
        return this.runGenericOutgoingDatafeedGenerator(region, brandCode);
      case "AndroidPayScanner":
        return this.runAndroidPayScanner(region, brandCode);
      case "RtpnBatchBarcodeRefresher":
        return this.runRtpnBatchBarcodeRefresher(region, brandCode);
      default:
        return this.runDefaultTask(region, brandCode, taskName);
    }   
  }

  runDaqDataBatchRefresher(region: string, brandCode: string): Observable<IMessage>{
    let baseUrl = this.sharedService.getBaseUrlByRegion(region);
    let url = baseUrl + this.refreshDaqDataUrl.replace('{brandCode}', brandCode);
    return this.http.post<IMessage>(url, null, {headers: this.baseHeaders, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }  

  runGenericDaqDatafeedImporter(region: string, brandCode: string): Observable<IMessage>{
    let baseUrl = this.sharedService.getBaseUrlByRegion(region);
    let url = baseUrl + this.importInboundFeedsUrl.replace('{brandCode}', brandCode);
    return this.http.post<IMessage>(url, null, {headers: this.baseHeaders, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }  

  runGenericOutgoingDatafeedGenerator(region: string, brandCode: string): Observable<IMessage>{
    let baseUrl = this.sharedService.getBaseUrlByRegion(region);
    let url = baseUrl + this.generateOutboundFeedsUrl.replace('{brandCode}', brandCode);
    return this.http.post<IMessage>(url, null, {headers: this.baseHeaders, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }  

  runAndroidPayScanner(region: string, brandCode: string): Observable<IMessage>{
    let baseUrl = this.sharedService.getBaseUrlByRegion(region);
    let url = baseUrl + this.runAndroidScannerUrl.replace('{brandCode}', brandCode);
    return this.http.post<IMessage>(url, null, {headers: this.baseHeaders, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }  

  runRtpnBatchBarcodeRefresher(region: string, brandCode: string): Observable<IMessage>{
    let baseUrl = this.sharedService.getBaseUrlByRegion(region);
    let url = baseUrl + this.rtpnBarcodeRefresherUrl.replace('{brandCode}', brandCode);
    return this.http.post<IMessage>(url, null, {headers: this.baseHeaders, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }  

  runDefaultTask(region: string, brandCode: string, taskName: string): Observable<IMessage>{
    let baseUrl = this.sharedService.getBaseUrlByRegion(region);
    let url = baseUrl + this.triggeredActionUrl.replace('{brandCode}', brandCode).replace('{eventName}', taskName);
    return this.http.post<IMessage>(url, null, {headers: this.baseHeaders, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }  

}
